<template>
  <div class="exp">
   <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate'>
      <option :value='true'>{{ $t('root.filters.true') }}</option>
      <option :value='false'>{{ $t('root.filters.false') }}</option>
    </select>

    <label>{{ $t('root.filters.status') }}</label>
    <multi-select v-model='selectedExpStatus' :options='status' />
    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../shared/_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    data() {
      return {
        predicate: true,
        selectedExpStatus: [],
      }
    },
    computed: {
      status() {
        return [
          { name: this.$t('calendar.soon_files'), id: 'soon' },
          { name: this.$t('calendar.current_files'), id: 'current' },
          { name: this.$t('calendar.expired_files'), id: 'expired' },
          { name: this.$t('calendar.no-date'), id: 'no_expiration' },
        ]
      },
      selectedStatusIds() {
        return this.selectedExpStatus.map(s => s.id)
      },
      predicateQuery() {
        return this.predicate ? 'filters[record_status_in]' : 'filters[record_status_not_in]'
      }
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        delete newQuery['filters[record_status_in]']
        delete newQuery['filters[record_status_not_in]']

        newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedStatusIds })

        this.$router.push({ query: newQuery })
      },
    }
  }
</script>

<style lang="sass" scoped>
.exp
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
</style>
